import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = {
  key: 1,
  class: "row w-full justify-between flex"
}
const _hoisted_3 = { class: "pt-5" }
const _hoisted_4 = {
  key: 0,
  class: "bg-white border border-lightgrey relative rounded"
}
const _hoisted_5 = { class: "pt-5 px-5 pb-5 flex flex-col h-full" }
const _hoisted_6 = { class: "noScrollbar auditDivHeight overflow-y-auto" }
const _hoisted_7 = { class: "addcompliancewidth" }
const _hoisted_8 = { class: "row flex flex-row w-full gap-5 mt-2 mb-3" }
const _hoisted_9 = { class: "w-6/12" }
const _hoisted_10 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_11 = {
  key: 0,
  class: "error-text"
}
const _hoisted_12 = { class: "w-6/12" }
const _hoisted_13 = ["min", "disabled"]
const _hoisted_14 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_15 = {
  key: 0,
  class: "error-text"
}
const _hoisted_16 = { class: "row flex flex-row w-full gap-5 items-center mb-3" }
const _hoisted_17 = { class: "w-6/12" }
const _hoisted_18 = ["disabled", "min"]
const _hoisted_19 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_20 = {
  key: 0,
  class: "error-text"
}
const _hoisted_21 = { class: "w-6/12" }
const _hoisted_22 = ["min", "disabled"]
const _hoisted_23 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_24 = {
  key: 0,
  class: "error-text"
}
const _hoisted_25 = { class: "row flex flex-row w-full gap-12 mb-3" }
const _hoisted_26 = { class: "w-6/12" }
const _hoisted_27 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_28 = {
  key: 0,
  class: "error-text"
}
const _hoisted_29 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_30 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_31 = { class: "w-6/12" }
const _hoisted_32 = { class: "inputboxstyling mt-2" }
const _hoisted_33 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_34 = {
  key: 0,
  class: "error-text"
}
const _hoisted_35 = { class: "row flex flex-row w-full gap-12 mb-3" }
const _hoisted_36 = { class: "w-6/12" }
const _hoisted_37 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_38 = {
  key: 0,
  class: "error-text"
}
const _hoisted_39 = { class: "w-6/12" }
const _hoisted_40 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_41 = {
  key: 0,
  class: "error-text"
}
const _hoisted_42 = { class: "row flex flex-row w-full gap-12 mb-3" }
const _hoisted_43 = { class: "w-6/12" }
const _hoisted_44 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_45 = {
  key: 0,
  class: "error-text"
}
const _hoisted_46 = { class: "w-6/12" }
const _hoisted_47 = {
  key: 0,
  class: "bottom-0 bg-white h-14 flex justify-between w-full rounded-b-sm flex-row-reverse",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_48 = { class: "flex items-center px-5 mx-5" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = {
  key: 1,
  class: "bg-white border border-lightgrey relative rounded"
}
const _hoisted_51 = { class: "pt-5 px-5 pb-5 flex flex-col h-full w-full noScrollbar teamsHeight overflow-y-auto" }
const _hoisted_52 = { class: "oneSideBorder pb-2 border-b border-lightgrey" }
const _hoisted_53 = { class: "justify-between items-center flex h-8 mt-3" }
const _hoisted_54 = { class: "flex justify-end" }
const _hoisted_55 = { class: "rounded flex text-xs mt-3" }
const _hoisted_56 = { class: "w-2/5" }
const _hoisted_57 = { class: "border border-lightgrey option mr-1 displayContainer overflow-y-scroll rounded" }
const _hoisted_58 = {
  key: 0,
  class: "p-2"
}
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "p-3 pl-5 cursor-pointer" }
const _hoisted_61 = { class: "text-xs" }
const _hoisted_62 = { class: "w-3/5" }
const _hoisted_63 = { class: "w-full pt-0" }
const _hoisted_64 = { class: "displayContainer border flex-col text-sm border-lightgrey overflow-y-scroll ml-1 rounded" }
const _hoisted_65 = {
  key: 0,
  class: "p-2"
}
const _hoisted_66 = { class: "flex items-center whitespace-nowrap" }
const _hoisted_67 = ["value", "id"]
const _hoisted_68 = ["for"]
const _hoisted_69 = { class: "pb-5 mb-14" }
const _hoisted_70 = {
  class: "bottom-0 bg-white h-14 flex justify-between w-full rounded-b-sm flex-row-reverse",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_71 = { class: "flex items-center px-5 mx-5" }
const _hoisted_72 = {
  key: 2,
  class: "bg-white border border-lightgrey relative rounded"
}
const _hoisted_73 = { class: "pt-5 px-5 pb-5 flex flex-col h-full w-full noScrollbar teamsHeight overflow-y-auto" }
const _hoisted_74 = {
  key: 0,
  class: "mb-10"
}
const _hoisted_75 = {
  class: "bottom-0 bg-white h-14 flex justify-between w-full rounded-b-sm flex-row-reverse",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_76 = { class: "flex items-center px-5 mx-5" }
const _hoisted_77 = ["disabled"]
const _hoisted_78 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_tableData = _resolveComponent("tableData")!
  const _component_newTable = _resolveComponent("newTable")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["px-5 pt-3", { 'details-in-modal': _ctx.modalMode }])
  }, [
    (!_ctx.modalMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_breadCrumbs, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.modalMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[27] || (_cache[27] = [
          _createElementVNode("h1", { class: "title" }, "Create - Compliance", -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.complianceDiv == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[42] || (_cache[42] = _createElementVNode("label", { class: "controllabel text-xs" }, "Compliance period", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                        onkeydown: "return false",
                        placeholder: "Select Date",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.presentComplianceObject.period.fromDate) = $event)),
                        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.checkFromPeriodFromDate && _ctx.checkFromPeriodFromDate(...args))),
                        class: _normalizeClass({
                    'is-invalid':
                      _ctx.v$.presentComplianceObject.period.fromDate.$error,'inputboxstylingForSelectAtPopup': _ctx.presentComplianceObject.period.fromDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.presentComplianceObject.period.fromDate !== ''
                  })
                      }, null, 34), [
                        [_vModelText, _ctx.presentComplianceObject.period.fromDate]
                      ]),
                      (_ctx.v$.presentComplianceObject.period.fromDate.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            (
                      _ctx.v$.presentComplianceObject.period.fromDate.required
                        .$invalid
                    )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Required "))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "p-1" }, "-", -1)),
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                        onkeydown: "return false",
                        min: _ctx.presentComplianceObject.period.fromDate,
                        placeholder: "Select date",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.presentComplianceObject.period.toDate) = $event)),
                        disabled: 
                    _ctx.presentComplianceObject.period.fromDate === ''
                      ? true
                      : false
                  ,
                        class: _normalizeClass({
                    'is-invalid':
                      _ctx.v$.presentComplianceObject.period.toDate.$error,'inputboxstylingForSelectAtPopup': _ctx.presentComplianceObject.period.toDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.presentComplianceObject.period.toDate !== ''
                  })
                      }, null, 42, _hoisted_13), [
                        [_vModelText, _ctx.presentComplianceObject.period.toDate]
                      ]),
                      (_ctx.v$.presentComplianceObject.period.toDate.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            (
                      _ctx.v$.presentComplianceObject.period.toDate.required.$invalid
                    )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Required "))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _cache[29] || (_cache[29] = _createElementVNode("label", { class: "controllabel text-xs" }, "Compliance Start Date", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        class: _normalizeClass(["mt-2", {
                    'is-invalid': _ctx.v$.presentComplianceObject.startDate.$error,'inputboxstylingForSelectAtPopup': _ctx.presentComplianceObject.startDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.presentComplianceObject.startDate !== ''
                  }]),
                        onFocus: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                        onkeydown: "return false",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.presentComplianceObject.startDate) = $event)),
                        onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.checkForStartDate && _ctx.checkForStartDate(...args))),
                        disabled: _ctx.presentComplianceObject.period.toDate == '',
                        min: _ctx.presentComplianceObject.period.fromDate > _ctx.today ? _ctx.presentComplianceObject.period.fromDate:_ctx.today,
                        placeholder: "Select Start Date"
                      }, null, 42, _hoisted_18), [
                        [_vModelText, _ctx.presentComplianceObject.startDate]
                      ]),
                      (_ctx.v$.presentComplianceObject.startDate.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            (
                      _ctx.v$.presentComplianceObject.startDate.required.$invalid
                    )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Required "))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "px-1 paddingTop" }, "-", -1)),
                    _createElementVNode("div", _hoisted_21, [
                      _cache[30] || (_cache[30] = _createElementVNode("label", { class: "controllabel text-xs" }, "Compliance End Date", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        class: _normalizeClass(["mt-2", {
                    'is-invalid': _ctx.v$.presentComplianceObject.endDate.$error,'inputboxstylingForSelectAtPopup': _ctx.presentComplianceObject.endDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.presentComplianceObject.endDate !== ''
                  }]),
                        onFocus: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                        onkeydown: "return false",
                        min: _ctx.presentComplianceObject.startDate,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.presentComplianceObject.endDate) = $event)),
                        placeholder: "Select End date",
                        disabled: 
                    _ctx.presentComplianceObject.startDate === '' ? true : false
                  
                      }, null, 42, _hoisted_22), [
                        [_vModelText, _ctx.presentComplianceObject.endDate]
                      ]),
                      (_ctx.v$.presentComplianceObject.endDate.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            (_ctx.v$.presentComplianceObject.endDate.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, " Required "))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _cache[33] || (_cache[33] = _createElementVNode("label", { class: "controllabel text-xs" }, "Compliance Title", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["inputboxstyling mt-2", {
                    'is-invalid': _ctx.v$.presentComplianceObject.title.$error || _ctx.checkComplianceNames(_ctx.presentComplianceObject.title)
                  }]),
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.presentComplianceObject.title) = $event)),
                        onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.presentComplianceObject.title.$touch())),
                        placeholder: "Compliance Title"
                      }, null, 34), [
                        [
                          _vModelText,
                          _ctx.presentComplianceObject.title,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.presentComplianceObject.title.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            (_ctx.v$.presentComplianceObject.title.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, "Required"))
                              : (_ctx.v$.presentComplianceObject.title.required && _ctx.v$.presentComplianceObject.title.restrictCharacters30.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, "Charcter Limit is exceeded"))
                                : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.checkComplianceNames(_ctx.presentComplianceObject.title))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, _cache[32] || (_cache[32] = [
                            _createElementVNode("div", { class: "error-text text-xs" }, "Compliance title already exists.", -1)
                          ])))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _cache[34] || (_cache[34] = _createElementVNode("label", { class: "controllabel text-xs" }, "Compliance Id", -1)),
                      _createElementVNode("div", _hoisted_32, _toDisplayString((_ctx.presentComplianceObject.complianceId).toUpperCase()), 1),
                      (_ctx.v$.presentComplianceObject.complianceId.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            (
                      _ctx.v$.presentComplianceObject.complianceId.required.$invalid
                    )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_34, " Required "))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _cache[35] || (_cache[35] = _createElementVNode("label", { class: "controllabel" }, "Compliance Lead", -1)),
                      _createVNode(_component_AutoComplete, {
                        modelValue: _ctx.presentComplianceObject.teamLeader,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.presentComplianceObject.teamLeader) = $event)),
                        suggestions: _ctx.userOptionsArr,
                        onComplete: _ctx.asyncFind,
                        optionLabel: "label",
                        optionValue: "value",
                        forceSelection: true,
                        placeholder: "Compliance Lead",
                        class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2", {
											'p-invalid': _ctx.v$.presentComplianceObject.teamLeader.$error,
										}])
                      }, null, 8, ["modelValue", "suggestions", "onComplete", "class"]),
                      (_ctx.v$.presentComplianceObject.teamLeader.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            (_ctx.v$.presentComplianceObject.teamLeader.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, " Required "))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _cache[37] || (_cache[37] = _createElementVNode("label", { class: "controllabel text-xs" }, "Frameworks (Maximum of 3 Frameworks)", -1)),
                      _createVNode(_component_MultiSelect, {
                        modelValue: _ctx.presentComplianceObject.frameworks,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.presentComplianceObject.frameworks) = $event)),
                        options: _ctx.auditFrameworkArray,
                        placeholder: "Location Name",
                        display: "chip",
                        maxSelectedLabels: 3,
                        filter: true,
                        class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                      'p-invalid': _ctx.v$.presentComplianceObject.frameworks.$error,
                    }]),
                        optionDisabled: (option) => option === 'InternalControls'
                      }, {
                        empty: _withCtx(() => _cache[36] || (_cache[36] = [
                          _createElementVNode("span", { class: "text-xs" }, "No Frameworks Found", -1)
                        ])),
                        _: 1
                      }, 8, ["modelValue", "options", "class", "optionDisabled"]),
                      (_ctx.v$.presentComplianceObject.frameworks.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            (
                      _ctx.v$.presentComplianceObject.frameworks.required.$invalid
                    )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_41, " Required "))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _cache[39] || (_cache[39] = _createElementVNode("label", { class: "controllabel text-xs" }, "Location", -1)),
                      _createVNode(_component_MultiSelect, {
                        modelValue: _ctx.presentComplianceObject.location,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.presentComplianceObject.location) = $event)),
                        options: _ctx.optionsLocationArray,
                        optionLabel: "label",
                        dataKey: "value",
                        filter: true,
                        display: "chip",
                        placeholder: "Location",
                        class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                  'p-invalid': _ctx.v$.presentComplianceObject.location.$error,
                }])
                      }, {
                        empty: _withCtx(() => _cache[38] || (_cache[38] = [
                          _createElementVNode("span", { class: "text-xs" }, "No Locations Found", -1)
                        ])),
                        _: 1
                      }, 8, ["modelValue", "options", "class"]),
                      (_ctx.v$.presentComplianceObject.location.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            (_ctx.v$.presentComplianceObject.location.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, "Required "))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _cache[41] || (_cache[41] = _createElementVNode("label", { class: "controllabel text-xs" }, "Compliance Members", -1)),
                      _createVNode(_component_MultiSelect, {
                        modelValue: _ctx.presentComplianceObject.complianceMembers,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.presentComplianceObject.complianceMembers) = $event)),
                        options: _ctx.complianceMembersOptions,
                        optionLabel: "label",
                        dataKey: "value",
                        filter: true,
                        display: "chip",
                        placeholder: "Compliance Members",
                        class: "w-full custom-multiselect userSelect mt-2"
                      }, {
                        empty: _withCtx(() => _cache[40] || (_cache[40] = [
                          _createElementVNode("span", { class: "text-xs" }, "No Members Found", -1)
                        ])),
                        _: 1
                      }, 8, ["modelValue", "options"])
                    ])
                  ])
                ])
              ])
            ]),
            (_ctx.complianceDiv == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["mr-2", _ctx.disableStatus? 'btnprimary': 'btndisabled pointer-events-none']),
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onCancelbtn()))
                    }, " Cancel ", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(( _ctx.disableStatus|| _ctx.pageType === 'edit') ? 'btnprimary' : 'btndisabled pointer-events-none'),
                      disabled: !(JSON.stringify(_ctx.dummyComplianceObj) !== JSON.stringify(_ctx.presentComplianceObject) || _ctx.pageType === 'edit'),
                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.nextFrameworkMapbtnAudit && _ctx.nextFrameworkMapbtnAudit(...args)))
                    }, " Next ", 10, _hoisted_49)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.complianceDiv == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _cache[43] || (_cache[43] = _createElementVNode("div", { class: "flex my-3" }, [
                      _createElementVNode("h2", { class: "header cursor-pointer" }, "Select Teams")
                    ], -1)),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("button", {
                        onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.addTeamsToTableView && _ctx.addTeamsToTableView(...args))),
                        class: _normalizeClass(
                  _ctx.AddButtonDisableCondition()
                    ? 'btnprimary'
                    : 'btndisabled pointer-events-none')
                      }, " Add ", 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        (_ctx.showFilters)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.entityFilters.entity) = $event)),
                                class: "inputboxstyling",
                                placeholder: "Search Entities"
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.entityFilters.entity,
                                  void 0,
                                  { trim: true }
                                ]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayEntitiesList, (location, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            onClick: ($event: any) => (_ctx.clickedLocation(location)),
                            class: _normalizeClass([
                    _ctx.selectedLocation == location.value
                      ? 'bg-primary hover:bg-primary text-white'
                      : 'hover:bg-lightgrey', "rounded"]),
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("p", _hoisted_61, _toDisplayString(location.label), 1)
                            ])
                          ], 10, _hoisted_59))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          (_ctx.showFilters)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.teamFilters.team) = $event)),
                                  class: "inputboxstyling",
                                  placeholder: "Search Teams"
                                }, null, 512), [
                                  [
                                    _vModelText,
                                    _ctx.teamFilters.team,
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayTeamList, (team, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "h-7 flex justify-normal items-center cursor-pointer p-5 hover:bg-lightgrey",
                              key: index
                            }, [
                              _createElementVNode("div", _hoisted_66, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.finalMappingObj[_ctx.selectedLocation]) = $event)),
                                  value: team._id,
                                  id: index,
                                  type: "checkbox",
                                  class: "checkbox"
                                }, null, 8, _hoisted_67), [
                                  [_vModelCheckbox, _ctx.finalMappingObj[_ctx.selectedLocation]]
                                ]),
                                _createElementVNode("label", {
                                  for: index,
                                  class: "pl-3 cursor-pointer"
                                }, _toDisplayString(team.displayName) + " (" + _toDisplayString(team.controlCount == undefined || team.controlCount == null ? team.controlCount : 0 || team.controlCount) + " " + _toDisplayString('Controls') + ")", 9, _hoisted_68)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _cache[44] || (_cache[44] = _createElementVNode("h2", { class: "header mt-2 cursor-pointer" }, "Selected Teams", -1)),
                  _createVNode(_component_tableData, {
                    tableRowData: _ctx.mappingTableTeamsArray,
                    headersData: _ctx.teamDisplayHeaders,
                    departmentArr: _ctx.filteredDepartments,
                    locations: _ctx.optionsLocationArray
                  }, null, 8, ["tableRowData", "headersData", "departmentArr", "locations"])
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("button", {
                    class: "btnprimary mr-2",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.goBack()))
                  }, "Back"),
                  _createElementVNode("button", {
                    class: _normalizeClass( _ctx.mappingTableTeamsArray.length > 0? 'btnprimary' : 'btndisabled pointer-events-none'),
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.nextFrameworkMapbtnAudit()))
                  }, " Next ", 2)
                ])
              ])
            ]))
          : (_ctx.complianceDiv == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  (_ctx.teamDetailsTableArray.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                        _createVNode(_component_newTable, {
                          tableRowData: _ctx.teamDetailsTableArray,
                          headersData: _ctx.detailsEditHeaders,
                          locations: _ctx.optionsLocationArray,
                          userArray: _ctx.filterUsersArray,
                          departmentArr: _ctx.filteredDepartments
                        }, null, 8, ["tableRowData", "headersData", "locations", "userArray", "departmentArr"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("button", {
                      class: "btnprimary mr-1.5",
                      onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.goBack()))
                    }, "Back"),
                    (_ctx.pageType == 'add')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btnprimary mr-1.5",
                          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.createNewCompliance())),
                          disabled: _ctx.clickOnButton
                        }, " Create ", 8, _hoisted_77))
                      : _createCommentVNode("", true),
                    (_ctx.pageType == 'edit')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus? 'btnprimary': 'btndisabled pointer-events-none']),
                          disabled: _ctx.clickOnButton,
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.updateCompliance()))
                        }, " Update ", 10, _hoisted_78))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
    ])
  ], 2))
}